export default __webpack_public_path__ + "static/montserrat-v15-latin-800-4e3c615967a2360f5db87d2f0fd2456f.woff";